module.exports = __webpack_public_path__ + "img/20005.880533fc.png";